import { Trash2 } from "lucide-react";
import { Button } from "@/frontend/components/ui/button";

/**
 * Destructive actions for one patient, last on Summary and open on arrival
 * rather than behind a disclosure. One row rather than a stack, with a solid red
 * button since nothing else on the page is red and this is the only thing here
 * that cannot be undone.
 */
export function PatientDangerZone({
  isIndividual,
  onDelete,
}: {
  isIndividual: boolean;
  onDelete: () => void;
}) {
  const action = isIndividual ? "Delete my records" : "Delete patient";

  return (
    <section className="flex shrink-0 flex-col gap-2">
      <h2 className="text-meta font-semibold uppercase tracking-wide text-destructive">
        Danger zone
      </h2>

      <div className="flex items-center gap-3 rounded-lg border border-destructive/30 p-4">
        <Trash2 className="size-4 shrink-0 text-destructive" />

        <div className="min-w-0 flex-1">
          <h3 className="text-body font-semibold">{action}</h3>
          <p className="mt-0.5 text-caption text-muted-foreground">
            {isIndividual
              ? "Permanently delete every record retrieved for you, across all connected health systems, and disconnect them. This cannot be undone."
              : "Permanently delete this patient and every record retrieved for them, across all connected health systems. This cannot be undone."}
          </p>
        </div>

        <Button variant="destructive" size="sm" className="shrink-0" onClick={onDelete}>
          {action}
        </Button>
      </div>
    </section>
  );
}
